export default __webpack_public_path__ + "static/media/hero.d1688da2.jpg";